/**
 * UI Auth Module
 * 
 * @package @capillarytech/cap-ui-utils
 * @author Rajshekar <rajshekar.venkatesh@capillarytech.com>
 */

import warn from '../utils/console/warn';
import log from '../utils/console/log';
import isEmpty from '../utils/isEmpty';
import hasAccess from './hasAccess';
import authHoc from './authHoc';
import hasRole from './hasRole';
import isCapUser from './isCapUser';
import hasFeatureAccess from './hasFeatureAccess';

const KEYS_EXEMPTED_FROM_VALIDATION = ['isCapUser']
/**
 * Function to initialize the capAuth configurations to the document
 * @param {*} authConfigs 
 */
function _initialize(authConfigs) {
  const capAuth = {};
  const { permissions, orgFeatures, roles, isCapUser, accessibleFeatures } = authConfigs;
  try {
    if (!permissions) {
      warn("Cannot initialize auth without permissions");
      return;
    }
    if(permissions) {
      capAuth.permissions = Object.freeze(permissions);
    }
    if(orgFeatures) {
      capAuth.orgFeatures = Object.freeze(orgFeatures);
    }
    if(roles) {
      capAuth.roles = Object.freeze(roles);
    }
    if(isCapUser) {
      capAuth.isCapUser = true;
    }
    if(accessibleFeatures) {
      capAuth.accessibleFeatures = Object.freeze(accessibleFeatures);
    }
    log("Cap auth initialized");
    window.capAuth = Object.freeze(capAuth);
  }
  catch(error) {
    warn(error);
  }
}

/**
 * Function to initialize Auth
 * @param {
 *  permissions, // Array of user permission
 *  orgFeatures, // Array of org Features
 * } authConfigs 
 * @param authOptions
 */
function initialize(authConfigs, authOptions) {
  if (isEmpty(authConfigs)) {
    warn("Cannot initialize empty object");
    return;
  }
  for ( const config in authConfigs) {
    if(KEYS_EXEMPTED_FROM_VALIDATION.includes(config)) {
      //Skip validation
      continue;
    }
    if(!["object"].includes(typeof authConfigs[config])) {
      warn("Config must be an object");
      return;
    }
  }
  _initialize(authConfigs);
  return true;
}

export default {
  initialize,
  hasAccess,
  authHoc,
  hasRole,
  isCapUser,
  hasFeatureAccess,
}

